var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sumCount"},[_c('div',{staticClass:"en"},[_vm._v("DETECTED")]),_c('div',{staticClass:"en"},[_vm._v("QUANTITY")]),_c('div',{staticClass:"cn"},[_vm._v("总检测量")]),_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.reportNumber))]),_c('img',{attrs:{"src":require("../../assets/images/ReagentType.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }